export default {
  title: 'Mobiele app',
  fields: {
    name: 'Appnaam',
  },
  buttons: {
    save: 'Opslaan',
  },
};
